<template>
  <div :style="gridItemStyles" class="panel stats">
    <div class="panel-header">
      <h3>{{ widget.title }}</h3>
    </div>
    <div class="panel-body">
      <component v-if="widgetComponent" :is="componentName" :series="series" :layout="widgetComponent.layout"></component>
    </div>
  </div>
</template>
<script>
  import LsMetricBanner from 'components/elements/LsMetricBanner';
  import PlotlyWidget from 'components/elements/PlotlyWidget';

  export default {
    components: {
      LsMetricBanner,
      PlotlyWidget
    },
    props: {
      widget: Object,
    },
    data () {
      return {
        widgetComponent: null,
      };
    },
    created () {
      this.widgetComponent = JSON.parse(this.widget.rendered_widget);
    },
    computed: {
      gridItemStyles () {
        return {
          gridColumn: this.widget.x + ' / span ' + this.widget.w,
          gridRow: this.widget.y + ' / span ' + this.widget.h
        };
      },
      componentName () {
        if (!this.widget) {
          return null;
        }
        switch (this.widget.engine) {
          case 'leadscorz':
            switch (this.widgetComponent.data.type) {
              case 'banner':
                return 'LsMetricBanner';
              default:
                return null;
            }
          case 'plotly':
            return 'PlotlyWidget';
        }
        return null;
      },
      series () {
        if (this.componentName == 'LsMetricBanner') {
          return this.widgetComponent.data.z;
        }
        else if (this.componentName == 'PlotlyWidget') {
          return this.widgetComponent.data;
        }
      }
    }
  }
</script>
<style>
  .panel-body {
    padding: .1rem!important;
  }
</style>



// WEBPACK FOOTER //
// DashboardWidget.vue?6f85cea0